import Camera from './Primitives/Camera.js';
import Sphere from './Primitives/Sphere.js';
import Renderer from './Render/Renderer.js';
import { RotateY } from './Math.js';

const ObjectsAmount = 78;
const CamMoveSpeed = 0.1;
const CamRotSpeed = 0.1;
var hooked = false;

export class App {
    constructor() {
    }
    Init() {
        if (!hooked) {
            window.addEventListener('resize', () => this.#renderer.Resize());
            window.addEventListener('keydown', (event) => this.#HandleKeyDown(event));
            window.addEventListener("keydown", function(e) {
                if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
                    e.preventDefault();
                }
            }, false);
            window.addEventListener("mousemove", (event) => this.#HandleMouseMovement(event));
            hooked = true;
        }

        this.#dispose = false;
        this.#camera = new Camera();
        this.#renderer = new Renderer();

        this.#renderer.SetCamera(this.#camera);
        this.#camera.SetPos([9., 8., 0.]);
        this.SetRot();

        for (var i = 0; i < ObjectsAmount; ++i) {
            var s = new Sphere(Math.random());
            s.MovePositionBy([Math.random() * 14.7 - 4, 3. + (Math.random() * 7.7), Math.random() * 28.7 - 14.]);
            this.#objects.push(s);
            this.#renderer.BindObject(this.#objects[this.#objects.length - 1]);
        }
    }

    SetRotA() {
        this.#camera.SetRotation(Math.PI * 1.9, Math.PI * -0.08, 0.);
    }

    SetRotB() {
        this.#camera.SetRotation(Math.PI * 2., Math.PI * -0.18, 0.);
    }

    SetRotC() {
        this.#camera.SetRotation(Math.PI * 3.0, Math.PI * -0.10, 0.);
    }

    #rotE = 0;
    SetRot() {
        this.#rotE = (this.#rotE + 1) % 2;
        if (this.#rotE == 0) {
            this.SetRotA();
            return;
        }
        if (this.#rotE == 1) {
            this.SetRotB();
            return;
        }
        if (this.#rotE == 2) {
            this.SetRotC();
            return;
        }
    }

    #start = false;
    async RunStart() {
        if (this.#start) {
            return;
        }
        this.Run();
        this.#start = true;
    }

    #semp = 0;
    async Run() {
        if (this.#semp != 0) {
            return;
        }
        ++this.#semp;

        if (this.#camera.GetPos()[2] <= -5.5) {
            this.#camera.SetPos([9., 8., 0.]);
            this.SetRot();
        } else {
            this.#camera.MovePositionBy([0.008, 0, .004]);
        }
        var sign = Math.sign(this.#curX);
        this.#curX = sign * Math.min(Math.abs(this.#curX), 0.05);
        sign = Math.sign(this.#curY);
        this.#curY = sign * Math.min(Math.abs(this.#curY), 0.05);

        this.#camera.MoveRotation(0, -this.#curX, 0);
        this.#camera.MoveRotation(-this.#curY, 0, 0);
        this.#camera.Update();

        if (!requestAnimationFrame(() => this.#renderer.Render())) {
            console.log("requestAnimationFrame() != 0");
        }

        --this.#semp;
        setTimeout(() => this.Run(), 32);
    }

    Dispose() {
        this.#dispose = true;
        this.#renderer.Dispose();
    }

    #HandleKeyDown(event) {
        switch (event.key) {
            case 'a':
                var lookDir = RotateY([1., 0., 0.], this.#camera.GetRot()[1]);
                lookDir[0] *= -CamMoveSpeed;
                lookDir[1] *= -CamMoveSpeed;
                lookDir[2] *= -CamMoveSpeed;

                this.#camera.MovePositionBy(lookDir);;
                break;
            case 'w':
                var lookDir = RotateY([0., 0., 1.], this.#camera.GetRot()[1]);
                lookDir[0] *= -CamMoveSpeed;
                lookDir[1] *= -CamMoveSpeed;
                lookDir[2] *= -CamMoveSpeed;

                this.#camera.MovePositionBy(lookDir);;
                break;
            case 's':
                var lookDir = RotateY([0., 0., 1.], this.#camera.GetRot()[1]);
                lookDir[0] *= CamMoveSpeed;
                lookDir[1] *= CamMoveSpeed;
                lookDir[2] *= CamMoveSpeed;

                this.#camera.MovePositionBy(lookDir);;
                break;
            case 'd':
                var lookDir = RotateY([1., 0., 0.], this.#camera.GetRot()[1]);
                lookDir[0] *= CamMoveSpeed;
                lookDir[1] *= CamMoveSpeed;
                lookDir[2] *= CamMoveSpeed;

                this.#camera.MovePositionBy(lookDir);;
                break;
            case 'ArrowUp':
                this.#camera.MoveRotation(CamRotSpeed, 0, 0);
                break;
            case 'ArrowDown':
                this.#camera.MoveRotation(-CamRotSpeed, 0, -0);
                break;
            case 'ArrowLeft':
                this.#camera.MoveRotation(0, CamRotSpeed, 0);
                break;
            case 'ArrowRight':
                this.#camera.MoveRotation(0, - CamRotSpeed, 0);
                break;
            default:
                break;
        }
    }

    #curX = 0;
    #curY = 0;
    #useMouse = true;

    #HandleMouseMovement(e) {
        var s = document.getElementById('BannerCanvas');
        if (s == null) {
            return;
        }
        if (e.clientX < (0.1 * s.width) || e.clientX > (0.9 * s.width)) {
            this.#useMouse = false;
        } else {
            this.#useMouse = true;
        }
        if (!this.#useMouse || (e.clientY < (0.1 * s.height) || e.clientY > (0.9 * s.height))) {
            this.#useMouse = false;
        } else {
            this.#useMouse = true;
        }

        if (!this.#useMouse) {
            this.#curX = 0;
            this.#curY = 0;
            return;
        }

        this.#curX = (e.movementX) * 0.001;
        this.#curY = (e.movementY) * 0.001;
    }

    #dispose = true;
    #renderer;
    #camera;
    #objects = [];
};

